<div *ngFor="let field of fields; trackBy: trackByField" [ngModelGroup]="field.name">
	<edit-field 
		[field]="field" 
		[values]="values[field.name]" 
		[parentForm]="parentForm" 
		(triggerBrowseEdit)="onBrowseEdit($event.fieldName, $event.index)"
		(triggerGeotag)="onGeotag($event.fieldName, $event.index)">
	</edit-field>
</div>
